import React, { useMemo } from 'react';
import { CompanionStage } from '../types';

interface CompanionProps {
  level: number;
  talking?: boolean;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const CompanionAvatar: React.FC<CompanionProps> = ({ level, talking = false, className = '', size = 'md' }) => {
  
  const stage = useMemo(() => {
    if (level < 3) return CompanionStage.EGG;
    if (level < 6) return CompanionStage.BABY;
    if (level < 10) return CompanionStage.FLYING;
    return CompanionStage.MASTER;
  }, [level]);

  const sizeClasses = {
    sm: 'w-10 h-10',
    md: 'w-24 h-24',
    lg: 'w-40 h-40'
  };

  const animationClass = talking ? 'animate-bounce' : 'animate-pulse';

  const renderVisual = () => {
    switch (stage) {
      case CompanionStage.EGG:
        return (
          <svg viewBox="0 0 100 100" className={`w-full h-full drop-shadow-lg ${animationClass}`}>
            <defs>
              <linearGradient id="eggGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#FFFACD" />
                <stop offset="100%" stopColor="#FCD34D" />
              </linearGradient>
            </defs>
            <ellipse cx="50" cy="50" rx="35" ry="45" fill="url(#eggGrad)" />
            <path d="M30 40 L45 50 L35 60" fill="none" stroke="rgba(0,0,0,0.1)" strokeWidth="2" />
          </svg>
        );
      case CompanionStage.BABY:
        return (
           <svg viewBox="0 0 100 100" className={`w-full h-full drop-shadow-lg ${animationClass}`}>
             <circle cx="50" cy="50" r="30" fill="#60A5FA" />
             <circle cx="40" cy="45" r="5" fill="white" />
             <circle cx="60" cy="45" r="5" fill="white" />
             <path d="M40 60 Q50 65 60 60" stroke="white" strokeWidth="3" fill="none" strokeLinecap="round" />
           </svg>
        );
      case CompanionStage.FLYING:
        return (
          <svg viewBox="0 0 100 100" className={`w-full h-full drop-shadow-lg ${animationClass}`}>
             <circle cx="50" cy="50" r="30" fill="#F472B6" />
             <path d="M15 45 Q5 20 45 15" fill="#F472B6" opacity="0.6" />
             <path d="M85 45 Q95 20 55 15" fill="#F472B6" opacity="0.6" />
             <circle cx="40" cy="45" r="6" fill="white" />
             <circle cx="60" cy="45" r="6" fill="white" />
             <ellipse cx="50" cy="80" rx="15" ry="5" fill="#38BDF8" className="animate-pulse" />
           </svg>
        );
      case CompanionStage.MASTER:
        return (
           <svg viewBox="0 0 100 100" className={`w-full h-full drop-shadow-xl ${animationClass}`}>
             <path d="M50 10 L90 30 L90 80 L50 100 L10 80 L10 30 Z" fill="#6366F1" />
             <circle cx="50" cy="45" r="20" fill="white" />
             <circle cx="45" cy="40" r="3" fill="#1E293B" />
             <circle cx="55" cy="40" r="3" fill="#1E293B" />
             <path d="M45 55 Q50 60 55 55" stroke="#1E293B" strokeWidth="2" fill="none" />
           </svg>
        );
    }
  };

  return (
    <div className={`relative flex items-center justify-center ${sizeClasses[size]} ${className}`}>
      {renderVisual()}
    </div>
  );
};
